module.exports = __webpack_public_path__ + "static/img/avatar-default.fcfb728.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar-default.png
// module id = 4sPK
// module chunks = 1